import { LeagueTierList } from './LeagueTierList';
import type { League } from '../services/leagueService';

interface LeagueHeaderProps {
    leagues: League[];
    currentRankLevel: number;
}

export const LeagueHeader = ({
    leagues,
    currentRankLevel
}: LeagueHeaderProps) => {
    return (
        <div className="pb-0">
            {/* Top Bar */}
            <div className="flex items-center justify-center mb-0 mt-0 text-white relative px-4">
                <h1 className="text-3xl font-bold font-persian">لیگ</h1>
            </div>

            {/* League Tiers Horizontal List - minimal spacing */}
            <div className="mb-0 mt-4">
                <LeagueTierList
                    leagues={leagues}
                    currentRankLevel={currentRankLevel}
                />
            </div>
        </div>
    );
};
